


export type BillDetailContentAlignment = 'Stretch' | 'Horizontal' | 'Vertical';

export const BillDetailContentAlignment = {
    Stretch: 'Stretch' as BillDetailContentAlignment,
    Horizontal: 'Horizontal' as BillDetailContentAlignment,
    Vertical: 'Vertical' as BillDetailContentAlignment
};

